import { createAction } from '@reduxjs/toolkit';

import { SET_DEAD_END_FOR_CLAIM_GROUP } from '../actionTypes/claimDeadEnd';

export const setDeadEndForClaimGroup = createAction(
  SET_DEAD_END_FOR_CLAIM_GROUP.BASE,
);
